import { DashboardActionTypes } from "./constants";

type DashboardAction = { type: string, payload: {} | string };
// common success
export const dashboardApiResponseSuccess = (actionType: string, data: any): DashboardAction => ({
    type: DashboardActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const dashboardApiResponseError = (actionType: string, error: string): DashboardAction => ({
    type: DashboardActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});
export const getActiveOffices = (): DashboardAction => ({
    type: DashboardActionTypes.GET_ACTIVE_OFFICES,
    payload: {},
});
export const getRegisteredVisits = (): DashboardAction => ({
    type: DashboardActionTypes.GET_REGISTERED_VISITS,
    payload: {},
});
export const getVisitsByCountry = (): DashboardAction => ({
    type: DashboardActionTypes.GET_VISITS_BY_COUNTRY,
    payload: {},
});
export const getVisitsByRegion = (): DashboardAction => ({
    type: DashboardActionTypes.GET_VISITS_BY_REGION,
    payload: {},
});

export const getInfoSended = (): DashboardAction => ({
    type: DashboardActionTypes.GET_INFO_SENDED,
    payload: {},
});

export const resetDashboard = (): DashboardAction => ({
    type: DashboardActionTypes.RESET,
    payload: {},
});

